import 'angular';

import { downgradeComponent } from '@angular/upgrade/static';

import { HeaderComponent } from './header.component';

angular.module('app-lite.header', [])
.directive('worHeader', downgradeComponent({ component : HeaderComponent }) as ng.IDirectiveFactory);
